<div class="container-fluid vh-100">
  <div class="row h-100">
    <div class="col-lg-6 d-flex flex-column bg-white p-5">
      <div class="row justify-content-center mt-auto mb-3">
        <div class="col">
          <div class="text-center">
            <img class="img-fluid logo" src="assets/images/logo-flat.png" alt="ALDDA Agencias">
          </div>
          <router-outlet></router-outlet>
        </div>
      </div>
      <div class="row text-center mt-auto mb-2">
        <div class="col">
          <a href="https://aldda.mx/" class="btn btn-outline-success fw-bold text-uppercase">
            <i class="fas fa-undo py-2 me-2"></i> Regresar a ALDDA.MX</a>
        </div>        
      </div>
      <div class="row text-center mt-auto">
        <p class="py-2">2026 © ALDDA Virtual, S.A. de C.V.</p>
      </div>
    </div>
    <div class="col-lg-6 col-sm-12 text-center d-none d-lg-block bg-login px-0">
      <div class="h-100 d-flex align-items-center justify-content-center">
        <img class="img-fluid" style="width: 80%;" src="assets/images/obj-login.png" alt="ALDDA VEH">
      </div>  
    </div>
  </div>
</div>